<script lang="ts">
  import { computed, defineComponent, h, PropType, toRefs } from 'vue';
  import { FindItem } from '@/composables/useAddressFinder';
  export default defineComponent({
    props: {
      suggestion: {
        type: Object as PropType<FindItem>,
        required: true,
      },
      class: {
        type: String as PropType<string>,
        default: '',
      },
      highlightClassStyle: {
        type: String as PropType<string>,
        default: '',
      },
    },
    setup(props) {
      const { suggestion } = toRefs(props);

      const highlightRange = computed(() => {
        if (!suggestion.value.Highlight) return [0, 0];
        return suggestion.value.Highlight?.split('-').map(st => parseInt(st, 10));
      });

      const shouldBeHighlighted = computed(() =>
        suggestion.value.Text.slice(highlightRange.value[0], highlightRange.value[1])
      );

      const beforeHighlight = computed(() =>
        suggestion.value.Text.slice(0, highlightRange.value[0])
      );

      const afterHighlight = computed(() => suggestion.value.Text.slice(highlightRange.value[1]));

      return () =>
        h('div', { class: props.class }, [
          beforeHighlight.value,
          h('span', { class: props.highlightClassStyle }, shouldBeHighlighted.value),
          afterHighlight.value,
        ]);
    },
  });
</script>
